module.exports = __webpack_public_path__ + "media/images/official/bnr_plancheck_pc-4f2879ef6a6dfbd728d76bdfcb817519.jpg";